export default "__VITE_ASSET__DwVc4wa3__"